import { render, staticRenderFns } from "./wizard1.vue?vue&type=template&id=3b4f1712"
import script from "./wizard1.vue?vue&type=script&lang=js"
export * from "./wizard1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/product/wizard1.vue
// module id = null
// module chunks = 